<span [attr.style]="style" *ngIf="imageUrl">
  <button
    cdsButton="inlineLink" class="card-art {{this.imageSize}} p-0 border-0" style="background: none;"
    [attr.title]="altText | adaFriendlyName: 'ariaLabel'"
    [mktRouterLink]="imageLink"
    [attr.target]="linkTarget"
    role="link"
    (click)="handleClicked($event)"
    (keyup.Enter)="handleClicked($event)"
    [attr.tabindex]="tabIndex"
    [disabled]="!imageLink"
  >
    <img *ngIf="imgCache"
       [ngSrc]="imageUrl"
      [attr.alt]="altText | adaFriendlyName: 'ariaLabel'"
      aria-hidden="true" role="presentation"
      [width]="width" [height]="height"
      [attr.priority]="priority"
    >
    <img *ngIf="!imgCache"
       [cache]="imageUrl" imgSrc [src]="imageUrl"
      [attr.alt]="altText | adaFriendlyName: 'ariaLabel'"
      aria-hidden="true" role="presentation"
      [width]="width" [height]="height"
      [attr.priority]="priority"
    >
  </button>
</span>
